export interface Features {
  isMemberMatch?: boolean;
  isOptionalSignupFlow?: boolean;
}

enum MutationName {
  onboardGuestMutation = 'onboardGuest',
  signUpNewMemberMutation = 'signUpNewMember',
  createMemberAccountMutation = 'createMemberAccount',
}

export const getMutationName = (
  isSignup: boolean,
  isPayLater: boolean,
  isExistingAccount: boolean,
  features: Features = {},
): MutationName => {
  const { isMemberMatch, isOptionalSignupFlow } = features;

  /**
   * DTOPPOR-1480 - When using BNPL the user is required to create an account.
   * The createMemberAccount mutation is used as it does not required a payment
   * method. The payment method is added after the user is redirected to the
   * member experience.
   */
  if (isPayLater) {
    return MutationName.createMemberAccountMutation;
  }

  /**
   * If we have detected that there is an existing account, and they in no opt
   * in treatment, we need to process this as a guest transaction, as they will
   * try to be member matched
   */
  // TODO: If we abstract this we can reuse it on the CI detection as well
  const isExistingAccountAndNoOptIn =
    isExistingAccount && isMemberMatch && isOptionalSignupFlow;

  return isSignup && !isExistingAccountAndNoOptIn
    ? MutationName.signUpNewMemberMutation
    : MutationName.onboardGuestMutation;
};
